import isJupyterDisabled from './isJupyterDisabled';

export default isJupyterDisabled;
